export default "__VITE_ASSET__CNidWVwK__"